// extracted by mini-css-extract-plugin
export default {"toolbar":"PageToolbar_toolbar__tA9VL","left":"PageToolbar_left__pupJM","right":"PageToolbar_right__jurb5"};